import { usePathname } from 'next/navigation'

export const useSafePathname = (): string => {
	const pathname = usePathname()
	return pathname ?? ''
}
